import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CanonicalService } from '../services/canonical.service';
import { JsonldService } from '../services/jsonld.service';
import { MetaSeoService } from '../services/meta-seo.service';

@Injectable({
  providedIn: 'root'
})
export class StockRecommendationHomeResolver implements Resolve<boolean> {

  constructor(
    private canonicalService: CanonicalService,
    @Inject(LOCALE_ID) private localId: Object,
    public jsonldService: JsonldService,
    private seoService:MetaSeoService,
  ){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const subSuffex="/stock-recommendation"
    const domain=environment.domain;
    const toYear = new Date().getFullYear();
    const lang=(this.localId+"").substring(0,2);
    let canonicalURL = domain+"/"+lang+subSuffex;
    let domainAndLangURL=domain+"/"+lang;
    let noIndex;
    const date = new Date().getFullYear();
    let title="Hisse Önerileri | Halka Arz"
    let description=toYear+" Hisse Önerileri, "+"güncel hisse önerileri, günlük hisse önerileri, haftalık hisse önerileri";
    if(lang!="tr"){
      title="Hisse Önerileri | Halka Arz"
      description=toYear+" Hisse Önerileri, "+"güncel hisse önerileri, günlük hisse önerileri, haftalık hisse önerileri";
    }
    this.canonicalService.setCanonicalURLForId(canonicalURL);
    this.seoService.setMetaAndTitle(title,description,canonicalURL,domainAndLangURL,noIndex);
    this.canonicalService.setWrapperAlternate(domain,subSuffex);
    this.jsonldService.removeJsonSnippet();
    this.jsonldService.setOrganization();
    this.jsonldService.setBreadCrumbListItem(domain,lang,"Hisse Önerileri",subSuffex)
    this.jsonldService.setWebSiteType(domain,lang);
    return null;
  }
}
